'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/location/Location.tsx
import { jsx } from "react/jsx-runtime";
var LocationIcon = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 4C8.68629 4 6 6.68629 6 10C6 12.5608 7.54775 15.0765 9.25529 17.0444C10.0926 18.0092 10.9326 18.8016 11.5639 19.3529C11.7244 19.493 11.871 19.6171 12 19.7241C12.129 19.6171 12.2756 19.493 12.4361 19.3529C13.0674 18.8016 13.9074 18.0092 14.7447 17.0444C16.4523 15.0765 18 12.5608 18 10C18 6.68629 15.3137 4 12 4ZM12 21C11.4086 21.8064 11.4083 21.8062 11.4081 21.806L11.4074 21.8055L11.4056 21.8042L11.4 21.8001L11.3815 21.7863C11.3659 21.7746 11.3438 21.758 11.3156 21.7365C11.2594 21.6937 11.1789 21.6316 11.0777 21.5514C10.8755 21.3909 10.5898 21.1574 10.2486 20.8594C9.5674 20.2647 8.65744 19.407 7.74471 18.3551C5.95225 16.2895 4 13.3052 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 13.3052 18.0477 16.2895 16.2553 18.3551C15.3426 19.407 14.4326 20.2647 13.7514 20.8594C13.4102 21.1574 13.1245 21.3909 12.9223 21.5514C12.8211 21.6316 12.7406 21.6937 12.6844 21.7365C12.6562 21.758 12.6341 21.7746 12.6185 21.7863L12.6 21.8001L12.5944 21.8042L12.5926 21.8055L12.5919 21.806C12.5917 21.8062 12.5914 21.8064 12 21ZM12 21L12.5914 21.8064L12 22.2401L11.4086 21.8064L12 21ZM11.9978 8.5C11.1694 8.5 10.4978 9.17157 10.4978 10C10.4978 10.8284 11.1694 11.5 11.9978 11.5C12.8262 11.5 13.4978 10.8284 13.4978 10C13.4978 9.17157 12.8262 8.5 11.9978 8.5ZM8.4978 10C8.4978 8.067 10.0648 6.5 11.9978 6.5C13.9308 6.5 15.4978 8.067 15.4978 10C15.4978 11.933 13.9308 13.5 11.9978 13.5C10.0648 13.5 8.4978 11.933 8.4978 10Z",
          fill: "currentColor"
        }
      )
    })
  );
};

export {
  LocationIcon
};
//# sourceMappingURL=chunk-KCP4LP4U.mjs.map